import request from '@/utils/request'
 // 查询供应商分配比例列表
 export function apiScpSopMpsSupplierAssignRatioList (query) {
    return request({
      url: `/scp/scpSopMpsSupplierAssignRatio/list`,
      method: 'get',
      params: query
    })
  }
   // 刷新新增供应商分配比例
 export function apiScpSopMpsSupplierAssignRatio (query) {
    return request({
      url: `/scp/scpSopMpsSupplierAssignRatio`,
      method: 'post',
      data: query
    })
  }
